import React from 'react';
import { TextField } from '@mui/material';
import { useReportingEditor } from '../../../../hooks/useReportingEditor';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const ReportDescriptionEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useReportingEditor(mode);

  return (
    <TextField
      size="small"
      fullWidth
      multiline
      rows={3}
      label="Description"
      value={request?.description || ''}
      onChange={(e) => updateRequest({ description: e.target.value })}
      placeholder="Provide a detailed description of the reporting request"
      InputProps={{
        sx: {
          alignItems: 'flex-start',
          '& .MuiInputBase-input': {
            paddingTop: '8px',
          }
        }
      }}
    />
  );
};

export default ReportDescriptionEditor;
